import {observer} from "mobx-react";
import {Bar, BarChart, ResponsiveContainer, Tooltip, XAxis, YAxis} from "recharts";
import {ChartDataItemType} from "../../../store";
import {ShipmentTypeDto} from "../../../api/kpi";
import {useEffect, useState} from "react";
import {displayShipmentType} from "../../../api";
import {
    ShippingReceiptExitDetailTooltipContent,
    shippingReceiptExitsBarChartColors
} from "./ShippingReceiptExitDetailTooltipContent";
import {TooltipCursor} from "./TooltipContent";

interface ShippingReceiptExitsBarChartProps {
    chartData: ChartDataItemType[]
    availableTypes: ShipmentTypeDto[]
}

const ShippingReceiptExitsBarChart = observer(function ShippingReceiptExitsBarChart({
                                                                                        chartData,
                                                                                        availableTypes
                                                                                    }: ShippingReceiptExitsBarChartProps) {


    const [types, setTypes] = useState<ShipmentTypeDto[]>([])
    const [data, setData] = useState<ChartDataItemType[]>([])

    useEffect(() => {
        setTypes(JSON.parse(JSON.stringify(availableTypes)) as ShipmentTypeDto[])
        setData(JSON.parse(JSON.stringify(chartData)) as ChartDataItemType[])
    }, [chartData, availableTypes])

    return <>
        <div style={{
            flex: '1',
            height: '20em'
        }}>
            <ResponsiveContainer>
                <BarChart data={data}>
                    {types.map((type) => {
                        const k = `exit_${type}`
                        return <Bar key={k} dataKey={k} name={`Ausgänge ${displayShipmentType(type)}`} stackId="exit"
                                    fill={shippingReceiptExitsBarChartColors[type]}/>
                    })}
                    {types.map((type) => {
                        const k = `receipt_${type}`
                        return <Bar key={k} dataKey={k} name={`Eingänge ${displayShipmentType(type)}`} stackId="receipt"
                                    fill={shippingReceiptExitsBarChartColors[type]}/>
                    })}
                    <XAxis dataKey="date"/>
                    <YAxis/>
                    <Tooltip cursor={<TooltipCursor />}
                             content={ShippingReceiptExitDetailTooltipContent}
                    />
                </BarChart>
            </ResponsiveContainer>
        </div>
    </>
})

export {
    ShippingReceiptExitsBarChart
}
